
import classNames from 'classnames/bind';
import globalStyles from './../style.css';

export default classNames.bind(globalStyles);
